import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { PageViewsData, PageViewsDataSchema } from '@/lib/schemas/dashboard';

export const usePageViews = (tenantId: string | null) => {
  return useQuery({
    queryKey: ['pageViews', tenantId],
    queryFn: async (): Promise<PageViewsData> => {
      if (!tenantId) {
        return {
          totalPageViews: 0,
          weeklyChange: 0,
          isPositive: false,
          changeLabel: "No data available"
        };
      }

      const { data, error } = await supabase.functions.invoke('get-posthog-stats', {
        body: { tenantId }
      });

      if (error) {
        console.error('Error fetching page views:', error);
        return {
          totalPageViews: 0,
          weeklyChange: 0,
          isPositive: false,
          changeLabel: "Error loading data"
        };
      }

      return PageViewsDataSchema.parse(data);
    },
    enabled: !!tenantId,
    staleTime: 60 * 60 * 1000, // Data is fresh for 1 hour
    gcTime: 60 * 60 * 1000, // Keep in cache for 1 hour
  });
};